import React from 'react';
import BootstrapModalTitle from '../bootstrap/ModalTitle.js';
import { jsx as _jsx } from "react/jsx-runtime";
function ModalTitle(props) {
  return /*#__PURE__*/_jsx(BootstrapModalTitle, {
    id: "modal-title",
    ...props
  });
}
export default ModalTitle;